import api from "../../utils/ApiConfig";

export const fetchGpsCoverage = async (month) => {
  const response = await api.get("/bo/livreurs/gps-coverage", { params: { month } });
  return response.data;
};
